import axios from "axios";
import {  getProposals } from '../api/ispyb.js';
import { FETCH_PROPOSAL } from '../constants/ActionTypes';

export function fetchProposals(user) {  
    return {
        type: FETCH_PROPOSAL,
        payload: axios.get(getProposals(user))      
    };     
}






// WEBPACK FOOTER //
// ./src/actions/proposals.js